<template>
  <div style="width: 330px;">
    <v-card style="height: 480px;" :style="{ backgroundColor: $ajustes.colorElemento }" elevation="1" class="line"
      :disabled="loading" :loading="loading">
      <h3 v-if="propNoticia.destacado == 1"
        style="position: absolute; color: gold; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;"
        class="ma-1">
        <v-icon class="mb-1" color="gold" small>mdi-star-circle</v-icon>
        DESTACADO
      </h3>
      <h1 class="ma-2 mb-0 mt-6" style="height: 45px; text-align: center; line-height: 20px; font-size: 12pt;">{{
        propNoticia.titulo }}</h1>
      <span class="ml-2" style="font-size: 10pt;">{{ propNoticia.fecha_noticia }}</span>
      <template v-slot:loader="{ isActive }">
        <v-progress-linear :active="isActive" color="deep-purple" height="4" indeterminate></v-progress-linear>
      </template>
      <v-container class="pa-0" style="height: 200px">
        <v-carousel v-if="imagenes.length > 0" cycle height="200" delimiter-icon="mdi-circle" show-arrows>
          <v-carousel-item v-for="(img, i) in imagenes" :key="i">
            <v-img :src="`${$env.pathImg}/${img}`" height="100%" cover class="rounded" />
          </v-carousel-item>
        </v-carousel>
        <v-container v-else class="center" style="overflow: hidden;">
          <v-img class="mt-1" width="100%" :src="imagenVacia" cover></v-img>
        </v-container>
      </v-container>
      <v-img v-if="false" class="mt-1" height="200px" :src="`${$env.pathImg}/${propNoticia.image_path}`" cover></v-img>
      <v-container style="height: 150px;">
        <span class="mt-3 mb-3" style="font-size: small;">{{ propNoticia.detalles }}</span>
      </v-container>
      <a v-if="esURL(propNoticia.enlace)" style="color: blue;" :href="propNoticia.enlace" target="_blank"><span
          style="font-size: small;" class="ma-2">Abrir enlace</span></a>
      <br>
      <br>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    propNoticia: { type: Object },
  },
  data() {
    return {
      imagenes: [
      ],
      imagenVacia: require('@/assets/default/is2.svg'),
      loading: false
    };
  },
  mounted() {
    try {
      const paths = JSON.parse(this.propNoticia.imagenes_ruta);
      this.imagenes = paths.map(p => `${p}`);
    } catch (e) {
      console.error("Error al parsear imágenes_ruta", e);
    }
  },
  watch: {
    'propNoticia.fecha_modificacion'() {
      try {
        const paths = JSON.parse(this.propNoticia.imagenes_ruta);
        this.imagenes = paths.map(p => `${p}`);
      } catch (e) {
        console.error("Error al parsear imágenes_ruta (por cambio de fecha_modificacion)", e);
      }
    }
  },
  created() { },
  computed: {},
  methods: {
    esURL(valor) {
      const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // http o https opcional
        '(([\\da-z.-]+)\\.([a-z.]{2,6})|' + // dominio
        '(([0-9]{1,3}\\.){3}[0-9]{1,3}))' + // o IP
        '(\\:[0-9]{1,5})?' + // puerto opcional
        '(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)*$', 'i'
      );
      return pattern.test(valor);
    }
  },
  continuar() { },
  close() { },
};
</script>
<style>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.v-carousel__controls {
  background-color: transparent;
}
</style>
